export default __webpack_public_path__ + "static/media/img1.90c4c7da.png";